import { useContext, useCallback } from 'react';
import { useDescendant, useHoverIntent } from "../../hooks";
import { TabsContext } from "./TabsContext";
import { getTabId, getPanelId } from "./get-accessibility-ids";
import { mergeProps } from '@react-aria/utils';
export function useTab(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onClickProp = _ref.onClick;

  var _useDescendant = useDescendant(null, ref),
      index = _useDescendant.index; // Gather Tablist context values


  var _useContext = useContext(TabsContext),
      id = _useContext.id,
      value = _useContext.value,
      onChange = _useContext.onChange,
      mountedTabs = _useContext.mountedTabs,
      onMountTabs = _useContext.onMountTabs;

  var isSelected = value === index;
  var onClick = useCallback(function (e) {
    onChange(index);

    if (onClickProp) {
      onClickProp(e);
    }
  }, [onChange, onClickProp, index]);
  /**
   * When the user shows intent, optimstically mount
   * our tab.
   */

  var onHoverIntent = useCallback(function () {
    if (mountedTabs.has(index)) {
      return;
    }

    var next = new Set(mountedTabs);
    next.add(index);
    onMountTabs(next);
  }, [index, mountedTabs, onMountTabs]);

  var _useHoverIntent = useHoverIntent(onHoverIntent),
      bindIntent = _useHoverIntent.bind;

  return {
    bind: mergeProps({
      role: 'tab',
      id: getTabId(id, index),
      'aria-controls': getPanelId(id, index),
      'aria-selected': isSelected,
      onClick: onClick,
      tabIndex: isSelected ? 0 : -1
    }, bindIntent),
    value: value,
    isSelected: isSelected
  };
}